// extracted by mini-css-extract-plugin
export default {"categoriesWrapper":"CategoriesProduct_categoriesWrapper__N0tw4"};